import { Plugin } from 'prosemirror-state';

import { AddMenuToggleList } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

function plugins({ t }: EditorOptions) {
  return [
    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.toggle_list.title') as string,
            description: t('Lygo:Menu.toggle_list.description') as string,
            icon: AddMenuToggleList,
            addMenuIcon: AddMenuToggleList,
            addMenuItemType: addMenuItemType.basic_blocks,
            searchWords: ['toggle', 'list'],
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
